import { render } from "./PeggedNFTBox.vue?vue&type=template&id=fd1bbe98&scoped=true"
import script from "./PeggedNFTBox.vue?vue&type=script&lang=js"
export * from "./PeggedNFTBox.vue?vue&type=script&lang=js"

import "./PeggedNFTBox.vue?vue&type=style&index=0&id=fd1bbe98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd1bbe98"

export default script